import styled from 'styled-components'

export const Icon = styled.svg.attrs({
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    version: '1.1',
    xmlns: 'http://www.w3.org/2000/svg'
})`
    pointer-events: all;
    cursor: pointer;
    margin: 0 10px;
`
